module.exports = __webpack_public_path__ + "static/media/r.8a90f5b8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/r.mp3
// module id = 107
// module chunks = 0